import CrudCustom from '../../../libs/custom/CrudCustom';

let TarifProgresifPensiunService = new CrudCustom('/tarif-pensiuns');
export default TarifProgresifPensiunService;
